import { Star, FileCheck, ShieldCheck } from "lucide-react";

const partners = [
  { name: "AXA", domain: "axa.ch", customLogo: "/logos/axa.png" },
  { name: "Zurich", domain: "zurich.ch", customLogo: "/logos/zurich.png" },
  { name: "Allianz", domain: "allianz.ch", customLogo: "/logos/allianz.png" },
  { name: "Helvetia", domain: "helvetia.com", customLogo: "/logos/helvetia.png" },
  { name: "Generali", domain: "generali.ch", customLogo: "/logos/generali.png" },
  { name: "Mobilière", domain: "mobiliere.ch", customLogo: "/logos/mobiliere.png" },
  { name: "Vaudoise", domain: "vaudoise.ch", customLogo: "/logos/vaudoise.png" },
  { name: "Baloise", domain: "baloise.ch", customLogo: "/logos/baloise.png" },
  { name: "TCS", domain: "tcs.ch", customLogo: "/logos/tcs.png" },
];

const LogoSet = () => (
  <>
    {partners.map((p) => {
      const src = p.customLogo;
      return (
        <div key={p.name} className="flex-shrink-0 flex items-center justify-center px-8">
          {/* Light mode */}
          <div className="dark:hidden bg-white/80 rounded-lg px-5 py-3">
            <img
              src={src}
              alt={`Logo ${p.name}`}
              className="h-14 object-contain opacity-90 hover:opacity-100 transition-opacity"
              width={56}
              height={56}
              loading="lazy"
              decoding="async"
            />
          </div>
          {/* Dark mode */}
          <div className="hidden dark:flex items-center justify-center">
            <img
              src={src}
              alt={`Logo ${p.name}`}
              className="h-14 object-contain brightness-0 invert opacity-70 hover:opacity-100 transition-opacity"
              width={56}
              height={56}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      );
    })}
  </>
);

const TrustBar = () => (
  <section className="py-8 border-y border-border/50 overflow-hidden" aria-label="Partenaires assurances">
    <div className="container mx-auto px-4">
      <p className="text-sm text-muted-foreground text-center mb-4">Nous traitons directement avec votre assurance</p>

      {/* Marquee */}
      <div className="relative mb-6 overflow-hidden">
        <div className="marquee-track flex items-center gap-4 animate-marquee w-max">
          <LogoSet />
          <LogoSet />
        </div>
      </div>

      {/* Badges */}
      <div className="flex items-center gap-6 flex-wrap justify-center">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <FileCheck className="w-4 h-4 text-primary" />
          <span>Gestion du sinistre incluse</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <ShieldCheck className="w-4 h-4 text-primary" />
          <span>Certifié constructeur</span>
        </div>
        <div className="flex items-center gap-2 text-sm">
          <div className="flex text-primary">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-current" />
            ))}
          </div>
          <span className="text-foreground font-semibold">5/5</span>
          <span className="text-muted-foreground">avis Google</span>
        </div>
      </div>
    </div>
  </section>
);

export default TrustBar;
